import {useEffect} from 'react';

import {ViewButton, ApplyButton, ManageButton} from '../buttons';


export default function Card({
                                 type = null,
                                 buttons,
                                 status = '',
                                 title = '',
                                 subtitle = '',
                                 infos = [],
                                onClick = () => {}
                             }) {
    const types = {
        'accepted': 1,
        'awaiting': 2,
        'declined': 3,
    }

    const TypeButtons = () => {
        return (
            <>
                <ViewButton/>
                <ManageButton/>
            </>
        )
    }

    const Buttons = () => {
        return (
            <>
                <ViewButton/>
                <ApplyButton onClick={() => window.location.href = "/myeb/grants/view/" + grant.id}/>
            </>
        )
    }



    return (
        <div className={`card ${type !== null && types[type] ? `card__type--${type}` : ""}`}>
            {
                types[type] &&
                <div className='card__top'>
                    <div>
                        <p>Status: <span style={{textTransform: 'capitalize'}}>{status}</span></p>
                        <p></p>
                    </div>
                    <div onClick={onClick} className="card-top__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12.728" height="7.778"
                             viewBox="0 0 12.728 7.778">
                            <path id="Path_8" data-name="Path 8"
                                  d="M12,13.172l4.95-4.95,1.414,1.414L12,16,5.636,9.636,7.05,8.222Z"
                                  transform="translate(-5.636 -8.222)" fill="#00d6d2"/>
                        </svg>
                    </div>
                </div>
            }
            <div className="card__content">
                <div>
                    <p className="card__title">{title}</p>
                    { subtitle && subtitle.length > 0 ? <p className="card__provider">{ subtitle }</p> : <p className="card__provider" style={{ fontSize: '15.5px' }}>ㅤ</p> }

                    <div className="card__information">
                        {
                            infos.map((i, index) => {
                                return (
                                    <div key={index} className="card-information__item">
                                        <p className="card-information-item__title">{i.label}</p>
                                        <p className="card-information-item__date">{i.value}</p>
                                    </div>

                                );
                            })
                        }
                    </div>
                </div>

                <div className="card__buttons">
                    {buttons ? buttons : ''}
                </div>
            </div>
        </div>
    )
}
